import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

const INPUT_CLASS =
  "w-full border border-white/10 bg-[#0d0d0d] px-4 py-3.5 text-sm font-light text-[#F5F5F5] placeholder:text-[#5a5a5a] transition-colors duration-300 focus:border-gold focus:outline-none rounded-none";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ylbh_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-ink px-6">
      <div className="gold-radial pointer-events-none absolute inset-0" aria-hidden="true" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md border border-white/10 bg-[#0A0A0A] p-10"
      >
        <div className="flex justify-center">
          <img src="/logo-full.png" alt="YLBH Sumatera Timur" className="h-16 w-auto" />
        </div>
        <h1 className="mt-8 text-center font-serif text-3xl text-[#F5F5F5]">
          Area Admin
        </h1>
        <p className="mt-2 text-center text-sm font-light text-[#A3A3A3]">
          Khusus tim YLBH Sumatera Timur.
        </p>

        <form data-testid="admin-login-form" onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label htmlFor="admin-email" className="mb-2 block text-[11px] font-medium uppercase tracking-[0.3em] text-[#A3A3A3]">
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@ylbhsumateratimur.id"
              className={INPUT_CLASS}
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-2 block text-[11px] font-medium uppercase tracking-[0.3em] text-[#A3A3A3]">
              Kata Sandi
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={INPUT_CLASS}
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300">
              {error}
            </p>
          )}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="group flex w-full items-center justify-center gap-3 bg-gold px-8 py-4 text-[13px] font-semibold uppercase tracking-[0.2em] text-ink transition-all duration-300 hover:bg-gold-light disabled:opacity-60"
          >
            {loading ? "Memeriksa…" : "Masuk"}
            {!loading && <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />}
          </button>
        </form>

        <div className="mt-8 text-center">
          <Link
            to="/"
            data-testid="admin-back-home"
            className="inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.25em] text-[#737373] transition-colors hover:text-gold"
          >
            <ArrowLeft size={13} /> Kembali ke Situs
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
